import {
    SET_BEACON
} from '../actions/const';

const initialState = {
    resetState: false,
    showModal: false,
    isLoadingAction: false,

    selectedData: null,
    formType: "",
    formTitle: "",
    formId: "",

    uuid: "",
    major: "",
    minor: "",
    hexNamespace: "",
    hexInstance: ""
};

function reducer (state = initialState, action) {
    let { type, payload } = action;
  
    switch (type) {
      case SET_BEACON:
        if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
          action.payload = {...initialState};
        }
        return Object.assign({}, state, action.payload);
        break;
  
      default:
        {
          return state;
        }
    }
  }
  
  module.exports = reducer;


// WEBPACK FOOTER //
// ./reducers/Beacon.js